import { useEffect } from 'react'
import "./subscriptionPage.css";
import SubscriptionHeader from './SubscriptionHeader';
import SubscriptionCard from './SubscriptionCard';
import { useNavigate } from 'react-router-dom';
import FormButton from '../formComponents/FormButton';
import ExampleCardsList from './ExampleCardsList';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { benefits } from '../../../dataSets/benefits';
import WebsitesList from './WebsitesList';

export default function SubscriptionPage() {
  useEffect(()=>{
    Aos.init({
      duration: 1000,
      once: true,
      easing: 'ease-in-out',
    });
    window.scrollTo({
      top:0,
      behavior:"smooth"
    })
    // let the example websites to load the page - then erase the local storage save for that current storage to avoid un necessary access to that data on the landing page
    setTimeout(() => {
      localStorage.removeItem("webingo_currentWebsite");
    }, 5000);
  },[])
  const nav = useNavigate();
  return (
    <div className='subscriptionPage' dir='rtl'>
      <div className='subscriptionPage_div'>
        <SubscriptionHeader/>
        <ExampleCardsList/>
        <WebsitesList/>
        <div className='subscriptionsList'>
          <SubscriptionCard subscription={benefits.business} header={"מנוי עסקי"} isActive={true} priceValue={75}/>
          <SubscriptionCard subscription={benefits.trial} header={"מנוי לתקופת ניסיון"} isActive={false} priceValue={35}/>
        </div>
        <p className='subscriptionPage_alreadySigned_p'>יש לך כבר מנוי?</p>
        <FormButton text={"התחבר"} action={()=>{nav("/webingo/signin")}}/>
      </div>
    </div>
  )
}
